// File: src/components/MainLayout.js

import React, { useState, useEffect } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { AiOutlineDashboard, AiOutlineShoppingCart } from "react-icons/ai";
import { FaUsersCog } from "react-icons/fa";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";

import {
  IoLogoAppleAr,
  IoCalendarOutline,
  IoCalendarSharp,
  IoBookOutline,
  IoMicSharp,
  IoRibbonSharp,
  IoTvOutline,
  IoBagRemoveSharp,
  IoManOutline,
  IoAlbumsOutline,
  IoBagAddOutline,
  IoSchoolOutline,
  IoPrintOutline,
  IoClipboardOutline,
} from "react-icons/io5";
import { GiMoneyStack } from "react-icons/gi";
import { FaUserTie } from "react-icons/fa";
import { FaSchool } from "react-icons/fa6";
import { MdPayment } from "react-icons/md";
import { TbBuildingEstate } from "react-icons/tb";
import { BiCategoryAlt } from "react-icons/bi";
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../utils/dateHelper";
import ConnectionStatus from "./ConnectionStatus";

const { Header, Sider, Content } = Layout;

const roleMenuItems = {
  admin: [
    {
      key: "",
      icon: <AiOutlineDashboard className="fs-4" />,
      label: "Dashboard",
    },
    {
      key: "customers",
      icon: <FaUserTie className="fs-4" />,
      label: "Registered VT/VC",
    },
    {
      key: "user-management",
      icon: <FaUsersCog className="fs-4" />,
      label: "User Management",
    },
    {
      key: "attendance",
      icon: <IoCalendarOutline className="fs-4" />,
      label: "Attendance",
    },
    {
      key: "curriculam",
      icon: <IoCalendarSharp className="fs-4" />,
      label: "Curriculam",
    },
    {
      key: "trainning-schedule",
      icon: <IoBookOutline className="fs-4" />,
      label: "Trainning Schedule",
    },
    {
      key: "guestlecture",
      icon: <IoMicSharp className="fs-4" />,
      label: "Guest Lectures",
    },
    {
      key: "industrial-visits",
      icon: <IoManOutline className="fs-4" />,
      label: "Industrial Visit",
    },
    {
      key: "mou-status",
      icon: <IoAlbumsOutline className="fs-4" />,
      label: "Mou Status",
    },
    {
      key: "vacant-position",
      icon: <IoBagAddOutline className="fs-4" />,
      label: "Vacant Position",
    },
    {
      key: "schools",
      icon: <FaSchool className="fs-4" />,
      label: "Schools",
    },
    {
      key: "students",
      icon: <IoSchoolOutline className="fs-4" />,
      label: "Students",
    },
    {
      key: "assesment-report",
      icon: <IoPrintOutline className="fs-4" />,
      label: "Assesment Report",
    },
    {
      key: "placement-report",
      icon: <IoClipboardOutline className="fs-4" />,
      label: "Placement Report",
    },
    {
      key: "payments",
      icon: <IoRibbonSharp className="fs-4" />,
      label: "Payments",
    },
    {
      key: "salary-records",
      icon: <GiMoneyStack className="fs-4" />,
      label: "Salary Records",
    },
    {
      key: "Catalog",
      icon: <IoLogoAppleAr className="fs-4" />,
      label: "Common Utils",
      children: [
        {
          key: "list-class",
          icon: <IoTvOutline className="fs-4" />,
          label: "Classes",
        },
        {
          key: "list-jobtrade",
          icon: <IoBagRemoveSharp className="fs-4" />,
          label: "Job Roles",
        },
        {
          key: "list-sectors",
          icon: <AiOutlineShoppingCart className="fs-4" />,
          label: "Trades / Sectors",
        },
        {
          key: "list-programs",
          icon: <BiCategoryAlt className="fs-4" />,
          label: "Programs",
        },
        {
          key: "statecluster",
          icon: <TbBuildingEstate className="fs-4" />,
          label: "State & Cluster",
        },
      ],
    },
    // ...add other admin menu items
  ],
  superadmin: [
    {
      key: "",
      icon: <AiOutlineDashboard className="fs-4" />,
      label: "Dashboard",
    },
    {
      key: "customers",
      icon: <FaUserTie className="fs-4" />,
      label: "Registered VT/VC",
    },
    {
      key: "user-management",
      icon: <FaUsersCog className="fs-4" />,
      label: "User Management",
    },
    {
      key: "attendance",
      icon: <IoCalendarOutline className="fs-4" />,
      label: "Attendance",
    },
    {
      key: "curriculam",
      icon: <IoCalendarSharp className="fs-4" />,
      label: "Curriculam",
    },
    {
      key: "trainning-schedule",
      icon: <IoBookOutline className="fs-4" />,
      label: "Trainning Schedule",
    },
    {
      key: "guestlecture",
      icon: <IoMicSharp className="fs-4" />,
      label: "Guest Lectures",
    },
    {
      key: "industrial-visits",
      icon: <IoManOutline className="fs-4" />,
      label: "Industrial Visit",
    },
    {
      key: "mou-status",
      icon: <IoAlbumsOutline className="fs-4" />,
      label: "Mou Status",
    },
    {
      key: "vacant-position",
      icon: <IoBagAddOutline className="fs-4" />,
      label: "Vacant Position",
    },
    {
      key: "schools",
      icon: <FaSchool className="fs-4" />,
      label: "Schools",
    },
    {
      key: "students",
      icon: <IoSchoolOutline className="fs-4" />,
      label: "Students",
    },
    {
      key: "assesment-report",
      icon: <IoPrintOutline className="fs-4" />,
      label: "Assesment Report",
    },
    {
      key: "placement-report",
      icon: <IoClipboardOutline className="fs-4" />,
      label: "Placement Report",
    },
    {
      key: "payments",
      icon: <IoRibbonSharp className="fs-4" />,
      label: "Payments",
    },
    {
      key: "salary-records",
      icon: <GiMoneyStack className="fs-4" />,
      label: "Salary Records",
    },
    {
      key: "Catalog",
      icon: <IoLogoAppleAr className="fs-4" />,
      label: "Common Utils",
      children: [
        {
          key: "list-class",
          icon: <IoTvOutline className="fs-4" />,
          label: "Classes",
        },
        {
          key: "list-jobtrade",
          icon: <IoBagRemoveSharp className="fs-4" />,
          label: "Job Roles",
        },
        {
          key: "list-sectors",
          icon: <AiOutlineShoppingCart className="fs-4" />,
          label: "Trades / Sectors",
        },
        {
          key: "list-programs",
          icon: <BiCategoryAlt className="fs-4" />,
          label: "Programs",
        },
        {
          key: "statecluster",
          icon: <TbBuildingEstate className="fs-4" />,
          label: "State & Cluster",
        },
      ],
    },
    // ...add other admin menu items
  ],
  subadmin: [
    {
      key: "",
      icon: <AiOutlineDashboard className="fs-4" />,
      label: "Dashboard",
    },
    {
      key: "customers",
      icon: <FaUserTie className="fs-4" />,
      label: "Registered VT/VC",
    },
    {
      key: "attendance",
      icon: <IoCalendarOutline className="fs-4" />,
      label: "Attendance",
    },
    {
      key: "curriculam",
      icon: <IoCalendarSharp className="fs-4" />,
      label: "Curriculam",
    },
    {
      key: "trainning-schedule",
      icon: <IoBookOutline className="fs-4" />,
      label: "Trainning Schedule",
    },
    {
      key: "guestlecture",
      icon: <IoMicSharp className="fs-4" />,
      label: "Guest Lectures",
    },
    {
      key: "industrial-visits",
      icon: <IoManOutline className="fs-4" />,
      label: "Industrial Visit",
    },
    {
      key: "mou-status",
      icon: <IoAlbumsOutline className="fs-4" />,
      label: "Mou Status",
    },
    {
      key: "vacant-position",
      icon: <IoBagAddOutline className="fs-4" />,
      label: "Vacant Position",
    },
    {
      key: "schools",
      icon: <FaSchool className="fs-4" />,
      label: "Schools",
    },
    {
      key: "students",
      icon: <IoSchoolOutline className="fs-4" />,
      label: "Students",
    },
    {
      key: "assesment-report",
      icon: <IoPrintOutline className="fs-4" />,
      label: "Assesment Report",
    },
    {
      key: "placement-report",
      icon: <IoClipboardOutline className="fs-4" />,
      label: "Placement Report",
    },
    {
      key: "payments",
      icon: <IoRibbonSharp className="fs-4" />,
      label: "Payments",
    },
    {
      key: "salary-records",
      icon: <GiMoneyStack className="fs-4" />,
      label: "Salary Records",
    },
  ],
  hr: [
    {
      key: "salary-payment",
      icon: <MdPayment className="fs-4" />,
      label: "Salary",
    },
  ],
  accountant: [
    {
      key: "",
      icon: <AiOutlineDashboard className="fs-4" />,
      label: "Dashboard",
    },
    {
      key: "payments",
      icon: <IoRibbonSharp className="fs-4" />,
      label: "Payments",
    },
    {
      key: "salary-records",
      icon: <GiMoneyStack className="fs-4" />,
      label: "Salary Records",
    },
  ],
};

const filterMenuItemsByRole = (role) => {
  const items = roleMenuItems[role] || [];
  return items;
};

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(window.innerWidth < 768);
  const [role, setRole] = useState(null);
  const [email, setEmail] = useState(null);
  // const { isDarkMode, toggleTheme } = useContext(ThemeContext);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const navigate = useNavigate();

  useEffect(() => {
    const storedRole = localStorage.getItem("role")
      ? JSON.parse(localStorage.getItem("role"))
      : null;
    const storedEmail = localStorage.getItem("email")
      ? JSON.parse(localStorage.getItem("email"))
      : null;

    setRole(storedRole);
    setEmail(storedEmail);

    if (!localStorage.getItem("token")) {
      navigate("/");
    }

    // Handle responsive collapse on window resize
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user");
    localStorage.removeItem("email");
    //navigate("/");
    window.location.href = "/";
  };

  const menuItems = filterMenuItemsByRole(role);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        breakpoint="md"
        collapsedWidth={window.innerWidth < 768 ? 0 : 70}
        onBreakpoint={(broken) => {
          setCollapsed(broken);
        }}
        style={{
          background: "linear-gradient(180deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
          boxShadow: "4px 0 20px rgba(0,0,0,0.3)",
          overflow: "auto",
          height: "100vh",
          position: "sticky",
          top: 0,
          left: 0,
          flexShrink: 0,
        }}
        width={220}
      >
        <div className="sidebar-logo">
          {!collapsed ? (
            <div className="sidebar-logo-full">
              <img
                width={38}
                height={32}
                src={`${process.env.PUBLIC_URL}/LNG_SKILLS_LOGO.png`}
                alt="logo"
              />
              <span className="sidebar-brand-name">LNJ Skills</span>
            </div>
          ) : (
            <div className="sidebar-logo-collapsed">
              <img
                width={32}
                height={28}
                src={`${process.env.PUBLIC_URL}/LNG_SKILLS_LOGO.png`}
                alt="logo"
              />
            </div>
          )}
        </div>

        <Menu
          mode="inline"
          defaultSelectedKeys={[""]}
          onClick={({ key }) => {
            if (key === "signout") {
              handleLogout();
            } else {
              navigate(key);
            }
          }}
          items={menuItems}
          style={{
            background: "transparent",
            border: "none",
            marginTop: 8,
          }}
          className="sidebar-menu"
        />
      </Sider>

      <Layout
        className="site-layout"
        style={{ transition: "all 0.2s", overflow: "auto" }}
      >
        <Header
          className="main-header d-flex justify-content-between align-items-center"
          style={{ padding: "0 24px 0 20px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}
        >
          <div className="header-left d-flex align-items-center gap-3">
            {React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                className: "trigger-btn",
                onClick: () => setCollapsed(!collapsed),
              }
            )}
            <div className="d-none d-md-block">
              <span className="last-updated-badge">
                Last Updated — {formatDate(new Date())}
              </span>
            </div>
            <div className="d-none d-md-block">
              <ConnectionStatus />
            </div>
          </div>

          <div className="header-right d-flex align-items-center gap-3">
            <div className="dropdown user-dropdown">
              <div
                role="button"
                id="userProfileDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                className="d-flex align-items-center gap-2 p-1 pe-3"
                style={{
                  cursor: "pointer",
                  borderRadius: "100px",
                  border: "1px solid #e2e8f0",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                  userSelect: "none",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "#c7d2fe";
                  e.currentTarget.style.backgroundColor = "rgba(79, 70, 229, 0.02)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "#e2e8f0";
                  e.currentTarget.style.backgroundColor = "#ffffff";
                }}
              >
                <div
                  className="user-avatar"
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "600",
                    fontSize: "13px",
                    boxShadow: "0 2px 4px rgba(59, 130, 246, 0.2)",
                  }}
                >
                  {role ? role.charAt(0).toUpperCase() : "A"}
                </div>
                <div className="user-info d-none d-md-block" style={{ lineHeight: "1.2" }}>
                  <div className="user-role" style={{ fontSize: "12px", fontWeight: "600", color: "#1e293b", textTransform: "capitalize" }}>
                    {role}
                  </div>
                  <div className="user-email" style={{ fontSize: "10px", color: "#64748b" }}>
                    {email}
                  </div>
                </div>
                <i className="fas fa-chevron-down ms-1" style={{ fontSize: "10px", color: "#94a3b8" }}></i>
              </div>

              <div 
                className="dropdown-menu dropdown-menu-end p-2 border-0" 
                aria-labelledby="userProfileDropdown"
                style={{
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                  borderRadius: "12px",
                  marginTop: "8px",
                  minWidth: "200px",
                  border: "1px solid #f1f5f9",
                }}
              >
                <div className="px-3 py-2 mb-1 d-block d-md-none" style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <div style={{ fontWeight: "600", fontSize: "13px", color: "#1e293b" }}>{role}</div>
                  <div style={{ fontSize: "11px", color: "#64748b" }}>{email}</div>
                </div>
                
                <button
                  type="button"
                  className="dropdown-item d-flex align-items-center gap-2 px-3 py-2"
                  style={{
                    borderRadius: "8px",
                    fontSize: "13px",
                    color: "#334155",
                    fontWeight: "500",
                    transition: "all 0.2s",
                    border: "none",
                    backgroundColor: "transparent",
                    textAlign: "left",
                    width: "100%",
                  }}
                  onClick={() => navigate("/admin/my-profile")}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f5f9";
                    e.currentTarget.style.color = "#2563eb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#334155";
                  }}
                >
                  <i className="fas fa-user-circle fs-6 text-primary"></i> My Profile
                </button>
                
                <div className="dropdown-divider" style={{ margin: "6px 0", borderColor: "#f1f5f9" }}></div>
                
                <button
                  type="button"
                  className="dropdown-item logout-item d-flex align-items-center gap-2 px-3 py-2"
                  style={{
                    borderRadius: "8px",
                    fontSize: "13px",
                    color: "#ef4444",
                    fontWeight: "500",
                    transition: "all 0.2s",
                    border: "none",
                    backgroundColor: "transparent",
                    textAlign: "left",
                    width: "100%",
                  }}
                  onClick={handleLogout}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#fef2f2";
                    e.currentTarget.style.color = "#dc2626";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#ef4444";
                  }}
                >
                  <i className="fas fa-sign-out-alt fs-6 text-danger"></i> Log Out
                </button>
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: 0,
            padding: 0,
            minHeight: "calc(100vh - 64px)",
            background: "#eaedf2",
          }}
        >
          <ToastContainer
            position="top-center"
            autoClose={250}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="light"
          />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
